import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Cancel, ContentCut } from "@mui/icons-material";
import ThemeToggle from "@/components/ThemeToggle";

export default function BookingCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar position="sticky" color="default" elevation={1}>
        <Toolbar sx={{ maxWidth: 672, mx: "auto", width: "100%", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: 1,
                bgcolor: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "primary.contrastText",
              }}
            >
              <ContentCut sx={{ fontSize: 18 }} />
            </Box>
            <Typography fontWeight={600}>{t("bookingCancel.appBarTitle")}</Typography>
          </Box>
          <ThemeToggle />
        </Toolbar>
      </AppBar>
      <Box sx={{ maxWidth: 448, mx: "auto", px: 2, py: 8, textAlign: "center" }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "warning.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
          }}
        >
          <Cancel sx={{ fontSize: 36, color: "warning.dark" }} />
        </Box>
        <Typography variant="h5" fontWeight="bold" gutterBottom data-testid="text-payment-cancelled">
          {t("bookingCancel.heading")}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 4 }}>
          {t("bookingCancel.body")}
        </Typography>
        <Card>
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {t("bookingCancel.cardBody")}
            </Typography>
          </CardContent>
        </Card>
        <Button variant="contained" sx={{ mt: 3 }} onClick={() => navigate("/")} data-testid="button-try-again">
          {t("common.tryAgain")}
        </Button>
      </Box>
    </Box>
  );
}
